/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import { PageProps } from "gatsby";
import React, { useEffect, useState } from "react";

import * as classNames from "./Layout.module.css";

import Footer from "./Footer";
import SiteNavigation, { SiteNavigationItem } from "./SiteNavigation";
import WordMark from "./WordMark";

type LayoutProps = Omit<PageProps, "children"> & {
  children: React.ReactNode;
};

const Layout: React.FC<LayoutProps> = ({ path, children = [] }) => {
  const [showWorkMark, setShowWordMark] = useState(false);
  useEffect(() => {
    setShowWordMark(path != "/");
  }, [path]);
  const navItems: SiteNavigationItem[] = [
    {
      href: "/archive/",
      children: "Blog",
    },
    {
      href: "/bibliography/",
      children: "Bibliography",
    },
    {
      href: "/results/",
      children: "Race Results",
    },
    {
      href: "https://github.com/kara-ryli",
      target: "_blank",
      children: "Code",
    },
  ];
  return (
    <div className={classNames.root}>
      <SiteNavigation items={navItems} />
      {showWorkMark && <WordMark className={classNames.nav} />}
      <main className={classNames.main}>{children}</main>
      <Footer className={classNames.footer} />
    </div>
  );
};

export default Layout;
